import React from 'react';
import Icon from '../../../components/AppIcon';

const PlanetaryPositionsSection = ({ data, isVisible, onToggle }) => {
  if (!data || data?.length === 0) return null;

  return (
    <section id="planetary-positions" className="scroll-mt-20">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 rounded-2xl blur-2xl" />
        <div className="relative bg-card/80 backdrop-blur-xl border-2 border-border/50 rounded-2xl shadow-cosmic overflow-hidden">
          <button
            onClick={onToggle}
            className="w-full flex items-center justify-between px-5 md:px-7 py-5 hover:bg-muted/30 transition-all duration-300 group"
            aria-expanded={isVisible}
          >
            <div className="flex items-center">
              <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center mr-4 shadow-glow group-hover:shadow-glow-lg transition-all duration-300">
                <Icon name="Globe" size={24} color="#ffffff" />
              </div>
              <div className="text-left">
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground font-thai">
                  ตำแหน่งดาวเคราะห์
                </h2>
                <p className="text-xs md:text-sm text-muted-foreground mt-0.5">Planetary Positions</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <span className="hidden sm:inline text-xs text-muted-foreground">
                {data?.length} planets
              </span>
              <Icon 
                name={isVisible ? "ChevronUp" : "ChevronDown"} 
                size={24} 
                className="text-muted-foreground group-hover:text-primary transition-colors duration-300"
              />
            </div>
          </button>

          {isVisible && (
            <div className="border-t-2 border-border/30">
              <div className="hidden lg:block overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gradient-to-r from-muted/50 to-muted/30">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-caption font-semibold text-foreground uppercase tracking-wide">
                        ดาวเคราะห์
                        <span className="block text-xs text-muted-foreground normal-case mt-0.5">Planet</span>
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-caption font-semibold text-foreground uppercase tracking-wide">
                        องศา
                        <span className="block text-xs text-muted-foreground normal-case mt-0.5">Degree</span>
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-caption font-semibold text-foreground uppercase tracking-wide">
                        ราศี
                        <span className="block text-xs text-muted-foreground normal-case mt-0.5">Zodiac Sign</span>
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-caption font-semibold text-foreground uppercase tracking-wide">
                        บ้าน
                        <span className="block text-xs text-muted-foreground normal-case mt-0.5">House</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border/30">
                    {data?.map((planet, index) => (
                      <tr key={index} className="hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent transition-all duration-300 group">
                        <td className="px-6 py-4 text-sm font-medium text-foreground">
                          <div className="flex items-center">
                            <div className="w-2 h-2 rounded-full bg-gradient-to-r from-primary to-secondary mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                            <div>
                              <span className="font-thai">{planet?.nameTh}</span>
                              <span className="block text-xs text-muted-foreground">{planet?.nameEn}</span>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-sm font-mono text-primary font-semibold">
                          {planet?.degree}°
                        </td>
                        <td className="px-6 py-4 text-sm text-foreground">
                          <span className="font-thai">{planet?.zodiacTh}</span>
                          <span className="block text-xs text-muted-foreground">{planet?.zodiacEn}</span>
                        </td>
                        <td className="px-6 py-4 text-sm font-mono text-secondary font-semibold">
                          {planet?.house}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="lg:hidden divide-y divide-border">
                {data?.map((planet, index) => (
                  <div key={index} className="p-4 hover:bg-muted/50 transition-smooth">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <h3 className="text-base font-medium text-foreground">{planet?.nameTh}</h3>
                        <p className="text-sm text-muted-foreground">{planet?.nameEn}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-base data-text font-medium text-foreground">{planet?.degree}°</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">ราศี (Zodiac)</p>
                        <p className="text-sm text-foreground">{planet?.zodiacTh}</p>
                        <p className="text-xs text-muted-foreground">{planet?.zodiacEn}</p>
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-1">บ้าน (House)</p>
                        <p className="text-sm data-text text-foreground">{planet?.house}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PlanetaryPositionsSection;